const TechIcons = [
	{
		id: 1,
		alt: 'sass',
		src: require('./icon_sass.png'),
	},
	{
		id: 2,
		alt: 'react',
		src: require('./icon_react.png'),
	},
	{ id: 3, alt: 'typescript', src: require('./icon_ts.png') },
	{
		id: 4,
		alt: 'python',
		src: require('./icon_python.png'),
	},
	{
		id: 5,
		alt: 'node',
		src: require('./icon_node.png'),
	},
	{
		id: 6,
		alt: 'stackOverFlow',
		src: require('./icon_so.png'),
	},
	{ id: 7, alt: 'git', src: require('./icon_git.png') },
];

const CoovMockUp = require('./mockup_coov.png');

const GitHubIcon = require('./icon_github.png');

export { TechIcons, CoovMockUp, GitHubIcon };
